"use strict";
class AlarmListChangeEvent {
    constructor() {
        this.Timestamp = new Date();
    }
}
exports.AlarmListChangeEvent = AlarmListChangeEvent;
